<template>
  <div>
    <el-date-picker
      v-model="StartTime"
      type="date"
      placeholder="开始时间"
      :picker-options="StartOptions"
      value-format="yyyy-MM-dd"
      :style="timerStyle"
      @change="changeTime(0)"
    >
    </el-date-picker>
    —
    <el-date-picker
      v-model="EndTime"
      type="date"
      placeholder="结束时间"
      value-format="yyyy-MM-dd"
      :picker-options="EndOptions"
      :style="timerStyle"
      @change="changeTime(1)"
    >
    </el-date-picker>
  </div>
</template>

<script>
import { timestampToTime } from "@/utils/util";
export default {
  props: {
    timerStyle: ""
  },
  data() {
    let that = this;
    return {
      EndOptions: {},
      EndOptions1: {
        disabledDate(time) {
          const date = new Date(new Date(that.StartTime).setHours(0, 0, 0, 0));
          // console.log(time,date);
          return time.getTime() > Date.now() || time.getTime() < date.getTime();
        },
        shortcuts: [
          {
            text: "一周",
            onClick(picker) {
              const date = new Date(that.StartTime);
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              if (date > Date.now()) {
                picker.$emit("pick", timestampToTime(Date.now()));
              } else {
                picker.$emit("pick", date);
              }
            }
          },
          {
            text: "两周",
            onClick(picker) {
              const date = new Date(that.StartTime);
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 14);
              if (date > Date.now()) {
                picker.$emit("pick", timestampToTime(Date.now()));
              } else {
                picker.$emit("pick", date);
              }
            }
          },
          {
            text: "一月",
            onClick(picker) {
              const date = new Date(that.StartTime);
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              if (date > Date.now()) {
                picker.$emit("pick", timestampToTime(Date.now()));
              } else {
                picker.$emit("pick", date);
              }
            }
          }
        ]
      },
      EndOptions2: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: null
      },
      StartOptions: {},
      StartOptions1: {
        disabledDate(time) {
          const date = new Date(that.EndTime);
          return time.getTime() > date.getTime();
        },
        shortcuts: [
          {
            text: "一周",
            onClick(picker) {
              const date = new Date(that.EndTime);
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          },
          {
            text: "两周",
            onClick(picker) {
              const date = new Date(that.EndTime);
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 14);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一月",
            onClick(picker) {
              console.log(that.EndTime);
              const date = new Date(that.EndTime);
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", date);
            }
          }
        ]
      },
      StartOptions2: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: null
      },
      StartTime: "",
      EndTime: ""
    };
  },
  watch: {
    StartTime(newVal) {
      if (newVal) {
        this.EndOptions = this.EndOptions1;
      } else {
        console.log("in");
        this.EndOptions = this.EndOptions2;
      }
    },
    EndTime(newVal) {
      if (newVal) {
        this.StartOptions = this.StartOptions1;
      } else {
        this.StartOptions = this.StartOptions2;
      }
    }
  },
  mounted() {
    /*
          思路：通过document文档，选中日期时间选择器元素，然后创建一个i标签，
                并指定其类名为el-icon-date，并将其插入到日期时间选择器元素中
                然后通过样式的控制调整其到时间选择器尾部的位置
         */
    let keyNode = document.querySelector(".el-date-editor");

    let iNode = document.createElement("i");
    iNode.setAttribute("class", "el-icon-date"); // el-icon-bottom
    keyNode.appendChild(iNode);
    keyNode.style.padding = "0 -10px";
    iNode.style.position = "absolute";
    iNode.style.top = "13px";
    iNode.style.left = "7px";
    iNode.style.color = "#c0c4cc";
    this.EndOptions = this.EndOptions2;
    this.StartOptions = this.StartOptions2;
    // 设置默认年份
    this.$bus.on("defualtTime", data => {
      this.StartTime = data[0];
      this.EndTime = data[1];
    });
    // 清空时间
    this.$bus.on("clearTimeInterval", data => {
      this.StartTime = "";
      this.EndTime = "";
    });
  },
  methods: {
    changeTime(val) {
      this.$emit("changeTime", [this.StartTime, this.EndTime]);
    }
  }
};
</script>

<style lang="less" scoped>
// 隐藏小时钟图标
/deep/ .el-date-editor {
  position: relative;

  .el-input__prefix {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Form/TimeInterval.vue